module.exports = "/build/web/svg/social/default/linkedin.5bb864d86a28e55821e560c8f6e8b8f6.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/default/linkedin.svg
// module id = 184
// module chunks = 24